import * as React from "react";
import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import { Company } from "../../../../domain/model/company";
import { Customer } from "../../../../domain/model/customer";
import { Project } from "../../../../domain/model/project";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import { TBreadcrumbItem } from "../../../type/common";
import CustomerProjectMain from "./customer_project_main";

interface IProps {
  isInit: boolean;
  isLoading: boolean;
  project: Project | null;
  company: Company | null;
  customer: Customer | null;
  handleCreateEntry: () => void;
  isEntry: boolean;
}

const CustomerProjectComponent: React.FC<IProps> = (props) => {
  const {
    isInit,
    project,
    company,
    customer,
    handleCreateEntry,
    isEntry,
    isLoading,
  } = props;

  // 初期化
  if (isInit) {
    return <Progress canAnimation={false} />;
  }

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.customerRoot,
    routeConfig.customerProjects,
    { text: project ? project.name : "" },
  ];

  return (
    <React.Fragment>
      {isLoading && <Progress canAnimation={false} />}
      <PageWrapper>
        <Breadcrumbs breadcrumbItems={breadcrumbItems} />
        <CustomerProjectMain
          project={project}
          company={company}
          customer={customer}
          handleCreateEntry={handleCreateEntry}
          isEntry={isEntry}
        />
      </PageWrapper>
    </React.Fragment>
  );
};

export default CustomerProjectComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/project/customer_project.tsx